export type Point = { x:number, y:number };
export type Points = Point[];
export type SnapPoint = Point | undefined;

export type LineType = 'horizontal' | 'vertical';
export type SnapLine = undefined | {
    point: Point;
    type: LineType;
};

export class SnapPoints {
    private annotationSnapPoints: Points = [];
    private snapPointMaxDistance:number = 60;

    private snapLineDeltaX:number = 150;
    private snapLineDeltaY:number = 150;

    public constructor(points: Points) {
        this.annotationSnapPoints = points;
    }

    public update(points: Points): void {
        this.annotationSnapPoints = points;
    }

    public detectSnapPoint(p: Point): SnapPoint {
        if (this.annotationSnapPoints.length === 0) {
            return undefined;
        }

        let minDistance = Infinity;
        let snapPoint:SnapPoint;
        for (const annotationSnapPoint of this.annotationSnapPoints) {
            const distance = Math.sqrt(
                (p.x - annotationSnapPoint.x) ** 2 + (p.y - annotationSnapPoint.y) ** 2,
            );
            if (distance < minDistance) {
                minDistance = distance;
                snapPoint = annotationSnapPoint;
            }
        }

        if (minDistance > this.snapPointMaxDistance) {
            return undefined;
        }

        return snapPoint;
    }

    public detectSnapLine(p: Point): SnapLine {
        if (this.annotationSnapPoints.length === 0) {
            return undefined;
        }

        let minDistance = Infinity;
        let minAbsoluteDistance = Infinity;

        let snapPoint:SnapPoint;
        let lineType:LineType | undefined;
        for (const annotationSnapPoint of this.annotationSnapPoints) {
            const deltaX = Math.abs(p.x - annotationSnapPoint.x);
            if (deltaX < this.snapLineDeltaX && deltaX <= minDistance) {
                const absoluteDistance = Math.sqrt(
                    (p.x - annotationSnapPoint.x) ** 2 + (p.y - annotationSnapPoint.y) ** 2,
                );
                if (absoluteDistance < minAbsoluteDistance) {
                    minDistance = deltaX;
                    minAbsoluteDistance = absoluteDistance;
                    snapPoint = annotationSnapPoint;
                    lineType = 'vertical';
                }
            }

            const deltaY = Math.abs(p.y - annotationSnapPoint.y);
            if (deltaY < this.snapLineDeltaY && deltaY <= minDistance) {
                const absoluteDistance = Math.sqrt(
                    (p.x - annotationSnapPoint.x) ** 2 + (p.y - annotationSnapPoint.y) ** 2,
                );
                if (absoluteDistance < minAbsoluteDistance) {
                    minDistance = deltaY;
                    minAbsoluteDistance = absoluteDistance;
                    snapPoint = annotationSnapPoint;
                    lineType = 'horizontal';
                }
            }
        }

        if (lineType === undefined) {
            return undefined;
        }

        return {
            type: lineType,
            point: snapPoint,
        };
    }
}
